"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../../ApiManagerAdmin");
var ApiConfig_1 = require("../../config/ApiConfig");
var ApiUser = /** @class */ (function (_super) {
    __extends(ApiUser, _super);
    function ApiUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_USER_GROUP_STAT_LIST = "api/statistics/statUserGroupByDate";
        _this.GET_GROUP = "/api/theme/getGroup";
        /**
         * theme 리스트 정렬 api
         * @accessToken
         * @themeId  : 정렬 대상 테마 ID
         * @groupIds : 정렬 순서 별 그룹 ID
         */
        _this.UserGroupList = function (accesstoken, startAt, endAt, timezone) {
            var data = {
                startAt: startAt,
                endAt: endAt,
                timezone: timezone,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_USER_GROUP_STAT_LIST,
                data: data,
            });
            return config;
        };
        return _this;
    }
    ApiUser.getInstance = function (initValue) {
        if (!ApiUser.classInstance) {
            this.classInstance = new ApiUser(initValue);
        }
        return this.classInstance;
    };
    return ApiUser;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiUser;
